
export default {
  data () {
    return {
    }
  },
  computed: {
    hasJobCreatePermission () {
      return this.hasAnyPermission('PERM_JOB_CREATE')
    },
    hasLeadsPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasJobEditPermission () {
      return this.hasAnyPermission('PERM_JOB_EDIT')
    },
    hasJobClosePermission () {
      return this.hasAnyPermission('PERM_JOB_CLOSE')
    },
    hasJobHotSettingPermission () {
      return this.hasAnyPermission('PERM_JOB_HOT_SETTING')
    },
    hasUploadCandidatePermission () {
      return this.hasAnyPermission(['PERM_JOB_CANDIDATE_UPLOAD', 'PREMIUM_CANDIDATE_UPLOAD'])
    },
    hasReferralPermission () {
      return this.hasAnyPermission('PREMIUM_REFERRAL')
    },
    hasAgencyManagementPermission () {
      return this.hasAnyPermission('PREMIUM_VENDOR_MANAGEMENT')
    },
    hasOnlySeeMyJobsPermission () {
      return this.hasAnyPermission('PERM_ONLY_SEE_MY_JOBS')
    },
    hasOnlyActionOnMyCandidatePermission () {
      return this.hasAnyPermission('PERM_ONLY_ACTION_ON_MY_CANDIDATE')
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
  },
  watch: {
  }
}
